import { validateContent } from '../../validations/content';
import { validateImages } from '../../validations/images';
import { validate, setErrorsFromValidationResults } from '../../validations/validate';
import { showNotification } from '../../../../../../app/common/helpers/notifications';
import { t } from '../../../../../infra/i18n';
export var validateStep = function (params) {
    var validationResults = validate(params, [validateContent, validateImages]);
    setErrorsFromValidationResults({ store: params.store, validationResults: validationResults });
    var hasAnyEmailError = validationResults.errors.some(function (error) {
        return error.field === 'emailBody' ||
            error.field === 'emailCoverImage' ||
            error.field === 'emailLogoImage' ||
            error.field === 'emailSubject' ||
            error.field === 'emailTitle';
    });
    if (hasAnyEmailError) {
        showNotification({
            title: t('engage:validation.finish_email_title'),
            message: t('engage:validation.finish_email_message'),
            level: 'error',
        });
    }
    var hasSmsError = validationResults.errors.some(function (error) { return error.field === 'smsBody'; });
    if (hasSmsError) {
        showNotification({
            title: t('engage:validation.sms_missing_title'),
            message: t('engage:validation.sms_missing_message'),
            level: 'error',
        });
    }
    var hasPushError = validationResults.errors.some(function (error) { return error.field === 'pushBody'; });
    if (hasPushError) {
        showNotification({
            title: t('engage:validation.push_missing_title'),
            message: t('engage:validation.push_missing_message'),
            level: 'error',
        });
    }
    return validationResults.isValid;
};
